import GTM_HANDLES from '#/shared/gtm-handles';
import { type UniqueRadioButtonValues } from '#/types/inputs';

export const BIKETOWN_COMPANY_1 = 'BIKETOWN';
export const BIKETOWN_COMPANY_2 = 'GBFS';

export const BUS_LAYER = 'BUS_LAYER';
export const MAX_LAYER = 'MAX_LAYER';
export const WES_LAYER = 'WES_LAYER';
export const PSC_LAYER = 'PSC_LAYER';

// Map tile layers
export const TRIMET_STREETS_LAYER = 'trimet';
export const TRIMET_3D_LAYER = 'trimet-3d';
export const TRIMET_DARK_LAYER = 'trimet-dark';
export const TRIMET_DARK_3D_LAYER = 'trimet-dark-3d';
export const TRIMET_SATELLITE_LAYER = 'trimet-satellite';
export const TRIMET_SATELLITE_ROUTES_LAYER = 'trimet-satellite-routes';

export const MAP_LAYER_OPTIONS: UniqueRadioButtonValues[] = [
  {
    label: { stringId: 'map.streetslayer' },
    value: TRIMET_STREETS_LAYER,
  },
  {
    label: { stringId: 'map.aerialslayer' },
    value: TRIMET_SATELLITE_LAYER,
  },
].map(layerOption => ({
  ...layerOption,
  dataGtm: GTM_HANDLES.layerButton.mapTiles,
}));

// These keys are in CONSTANT_CASE, but our convention for localStorage
// keys is camelCase. We’ve kept them as-is to preserve existing user
// settings, but new keys should use camelCase
export const REALTIME_VEHICLES_TOGGLED_KEY = 'REALTIME_VEHICLES_TOGGLED';
export const SHOW_EXTRA_MAP_CONTROLS_ON_MOBILE_KEY = 'ALWAYS_SHOW_MAP_CONTROLS';

export const DUMMY_LNG = -122.68281340599061;
export const DUMMY_LAT = 45.52218740036735;

export const DEFAULT_ROUTE_COLOR = '#136390';

export const VEHICLE_ICON_BASE_PX = 23;

// Route line widths (in px) by zoom level. Format is [zoom, thickness]
export const ROUTE_LINE_WIDTH_BY_ZOOM: [number, number][] = [
  [8, 2],
  [10, 4],
  [15, 6.5],
  [19, 20],
];

// Tracked vehicle icon sizes by zoom level. Format is [zoom, thickness]
export const TRACKED_VEHICLE_ICON_PIXEL_SIZE_BY_ZOOM: [number, number][] = [
  [8, 4],
  [10, 8],
  [16, 22.5],
  [19, 60],
];

// Default vehicle icon sizes by zoom level. Format is [zoom, size]
export const DEFAULT_VEHICLE_ICON_SIZE_BY_ZOOM: [number, number][] = [
  [9, 0.1],
  [10, 0.19],
  [11, 0.26],
  [12, 0.31],
  [13, 0.41],
  [14, 0.45],
  [15, 0.48],
  [16, 0.75],
  [17, 1.3],
  [18, 1.6],
  [19, 1.9],
  [20, 2.17],
];
